import { create } from 'zustand';

type CreateGoalModalStoreProps = {
	isOpen: boolean;
	targetUserId?: string;
	onClose: () => void;
	onOpen: (targetUserId?: string) => void;
};

export const useCreateGoalModalStore = create<CreateGoalModalStoreProps>((set) => ({
	isOpen: false,
	targetUserId: undefined,
	onClose: () => set({ isOpen: false, targetUserId: undefined }),
	onOpen: (targetUserId?: unknown) => {
		// Defensively handle non-string values (e.g., click events passed by onClick handlers)
		const userId = typeof targetUserId === 'string' ? targetUserId : undefined;
		set({ isOpen: true, targetUserId: userId });
	},
}));

export const useCreateGoalModal = () => useCreateGoalModalStore((state) => state);
